import React from 'react';
import { useTheme } from '../../context/shared/ThemeContext'
import { ChartBarIcon, ShieldExclamationIcon, DocumentTextIcon, UserGroupIcon, ClockIcon } from '@heroicons/react/24/outline';

type View = 'trends' | 'risk' | 'reports' | 'cohort' | 'scheduler';

interface ClinicalToolsNavProps {
  currentView: View;
  setCurrentView: (view: View) => void;
}

const navItems = [
  { id: 'trends', name: 'Symbolic Trends', icon: ChartBarIcon },
  { id: 'risk', name: 'Risk Dashboard', icon: ShieldExclamationIcon },
  { id: 'reports', name: 'Reporting', icon: DocumentTextIcon },
  { id: 'cohort', name: 'Cohort Analysis', icon: UserGroupIcon },
  { id: 'scheduler', name: 'Message Scheduler', icon: ClockIcon },
];

const ClinicalToolsNav: React.FC<ClinicalToolsNavProps> = ({ currentView, setCurrentView }) => {
  const { themeClasses, isDarkMode } = useTheme();

  return (
    <nav className={`p-4 rounded-lg ${themeClasses.cardBg} ${themeClasses.border}`}>
      <ul className="space-y-2">
        {navItems.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => setCurrentView(item.id as View)}
              className={`w-full flex items-center p-3 text-sm font-medium rounded-md transition-colors ${
                currentView === item.id
                  ? 'bg-indigo-600 text-white'
                  : 'text-gray-700 bg-white hover:bg-gray-100 border border-gray-200'
              }`}
            >
              <item.icon className="w-5 h-5 mr-3" />
              <span>{item.name}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ClinicalToolsNav; 